var timer = [];

function ajaxAddToCart(e, id) {
  jQuery.post('/cart/add.json', {quantity: 1, id: id })
  .done(function () {
    updateCartMenu();
  });
  $('.added-to-basket-popup').addClass('show');
  setTimeout(function() {
    $('.added-to-basket-popup').removeClass('show');
  }, 3000);
}

function updateCartMenu() {
  jQuery.getJSON('/cart.js', function(cart) {
    // now have access to Shopify cart object
    $('#cart-count-ajax').text(cart.item_count);
    $('#cart-total-ajax').text(cart.total_price);
 });   
}




function updateCartCookie(cvalue) {
 
  var d = new Date();
  var exdays = 7;
  var cname = 'cart_count';
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires;
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires;
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

shopifyCart = function() { //call this on page load
  var cartCookie = getCookie('cart_count'); //Get shopify cart cookie
  // console.log(0);
  // console.log(cartCookie);
  if (cartCookie !== undefined && cartCookie !== '') {
    // console.log(1);
    if (cartCookie !== getCookie('cart_checker')) //reference cart_checker
    {
      // console.log(2);
      $('.added-to-basket-popup').addClass('show');
      setCookie('cart_checker', cartCookie); //set cookie for next time comparison
      //Do your action on the event
      setTimeout(function() {
        $('.added-to-basket-popup').removeClass('show');
      }, 3000);
    }
  }
};

function navigationAnimation(x) {
  // console.log('lets-talk');
  if (x == 'show') {

    $('body').addClass('lets-talk');
    if ($('body').hasClass('lets-shop')) {

      $('.bubble-2').removeClass('blueRubberBandUp').addClass('blueRubberBandDown').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
        //$('.header-navigation-2').removeClass('slideInDown').addClass('slideOutUp').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
        $('.header-navigation').removeClass('slideInDown').addClass('slideOutUp').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {

          $('body').removeClass('lets-shop');

          // $('.header-link.lets-shop a').removeClass('active');
          $('.bubble-white').removeClass('rubberBandDown').addClass('rubberBandUp');
          //$('.header-navigation').removeClass('slideOutUp').addClass('slideInDown').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
          $('.header-navigation-2').removeClass('slideOutUp').addClass('slideInDown').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {

            // console.log(1);
            if ($('.all-teas-menu').hasClass('bounceInDown')) {
              $('.all-teas-menu').addClass('bounceOutUp');
              $('.all-teas-menu').removeClass('bounceInDown');
            }
            $('.bubble').removeClass('blueRubberBandDown').addClass('blueRubberBandUp').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
              // $('.header-link.lets-talk-tea a').addClass('active');
            });
          });
        });
      });


    } else {
      $('.bubble-white').removeClass('rubberBandDown').addClass('rubberBandUp');
      //$('.header-navigation').removeClass('slideOutUp').addClass('slideInDown').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
      $('.header-navigation-2').removeClass('slideOutUp').addClass('slideInDown').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
        // console.log(1);
        if ($('.all-teas-menu').hasClass('bounceInDown')) {
          $('.all-teas-menu').addClass('bounceOutUp');
          $('.all-teas-menu').removeClass('bounceInDown');
        }
        $('.bubble').removeClass('blueRubberBandDown').addClass('blueRubberBandUp').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
          // $('.header-link.lets-talk-tea a').addClass('active');
        });
      });
    }
  } else {
    $('body').removeClass('lets-talk');

    // console.log(222);
    $('.bubble').removeClass('blueRubberBandUp').addClass('blueRubberBandDown').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
      // console.log(8);
      $('.bubble-white').removeClass('rubberBandUp').addClass('rubberBandDown')
      //$('.header-navigation').removeClass('slideInDown').addClass('slideOutUp').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
      $('.header-navigation-2').removeClass('slideInDown').addClass('slideOutUp').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
        // $('.header-link.lets-talk-tea a').removeClass('active');
      });
    });
  }
};

function navigationAnimation_2(x) {
  // console.log('lets-shop');
  if (x == 'show') {

    $('body').addClass('lets-shop');
    if ($('body').hasClass('lets-talk')) {

      $('.bubble').removeClass('blueRubberBandUp').addClass('blueRubberBandDown').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
        //$('.header-navigation').removeClass('slideInDown').addClass('slideOutUp').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
        $('.header-navigation-2').removeClass('slideInDown').addClass('slideOutUp').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
          $('body').removeClass('lets-talk');

          // $('.header-link.lets-talk-tea a').removeClass('active');
          $('.bubble-white').removeClass('rubberBandDown').addClass('rubberBandUp');
          // $('.header-navigation-2').removeClass('slideOutUp').addClass('slideInDown').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
          $('.header-navigation').removeClass('slideOutUp').addClass('slideInDown').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
            // console.log(1);
            if ($('.all-teas-menu').hasClass('bounceInDown')) {
              $('.all-teas-menu').addClass('bounceOutUp');
              $('.all-teas-menu').removeClass('bounceInDown');
            }
            $('.bubble-2').removeClass('blueRubberBandDown').addClass('blueRubberBandUp').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
              // $('.header-link.lets-shop a').addClass('active');
            });
          });
        });
      });


    } else {
      $('.bubble-white').removeClass('rubberBandDown').addClass('rubberBandUp');
      // $('.header-navigation-2').removeClass('slideOutUp').addClass('slideInDown').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
      $('.header-navigation').removeClass('slideOutUp').addClass('slideInDown').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
        // console.log(1);
        if ($('.all-teas-menu').hasClass('bounceInDown')) {
          $('.all-teas-menu').addClass('bounceOutUp');
          $('.all-teas-menu').removeClass('bounceInDown');
        }
        $('.bubble-2').removeClass('blueRubberBandDown').addClass('blueRubberBandUp').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
          // $('.header-link.lets-shop a').addClass('active');
        });
      });
    }
  } else {
    $('body').removeClass('lets-shop');

    // console.log(222);
    $('.bubble-2').removeClass('blueRubberBandUp').addClass('blueRubberBandDown').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
      // console.log(8);
      $('.bubble-white').removeClass('rubberBandUp').addClass('rubberBandDown')
      // $('.header-navigation-2').removeClass('slideInDown').addClass('slideOutUp').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
      $('.header-navigation').removeClass('slideInDown').addClass('slideOutUp').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {      
        // $('.header-link.lets-shop a').removeClass('active');
      });
    });
  }
};




function debounce(fn, delay) {
  var timer = null;
  return function() {
    var context = this,
      args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function() {
      fn.apply(context, args);
    }, delay);
  };
}

function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last,
    deferTimer;
  return function() {
    var context = scope || this;

    var now = +new Date,
      args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function() {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

function scaler() {

  var $window = $(window);
  var windowWidth = $window.width();
  var windowHeight = $window.height();

  if (($('body').hasClass('blog')) || ($('body').hasClass('blog-recipes'))) {
    $('.text').each(function() {

      $(this).css({
        height: ($(this).find('.text-sizer').height())
      });
    });
  }
  if ($('body').hasClass('page-tea-and-wellbeing')) {
    $('.text').each(function() {

      $(this).css({
        height: ($(this).find('.text-sizer').height())
      });
    });
  }
  if ($('body').hasClass('page-discover-rooibos')) {
    $('.text').each(function() {

      $(this).css({
        height: ($(this).find('.text-sizer').height())
      });
    });
  }
  if ($('body').hasClass('page-who-we-are')) {
    $('.text').each(function() {

      $(this).css({
        height: ($(this).find('.text-sizer').height())
      });
    });
  }



  if ($('body').hasClass('page-original-tea-range')
    // || $('body').hasClass('page-wellbeing-tea-range')
  ) {
    var backgroundSize = 600;
    var backgroundPositionHorizontal = (windowWidth / 4) - (backgroundSize / 2);
    var backgroundPositionVertical = (windowHeight / 2) + 47 - (backgroundSize / 2);

    if (windowWidth > 2420) {
      backgroundPositionHorizontal = 305 + ((windowWidth - 2420) / 2);
    }
    $('.page-original-tea-range article #products .section .bg-tea').css({
      'background-position': (backgroundPositionHorizontal + 'px ' + backgroundPositionVertical + 'px')
    });

  }
  if (($('body').hasClass('blog')) || ($('body').hasClass('blog-recipes')) || ($('body').hasClass('page-tea-and-wellbeing')) || ($('body').hasClass('page-discover-rooibos')) || ($('body').hasClass('page-who-we-are'))) {

    var contentWrapperWidth = $('.width-one-half.height-two').width();
    if (windowWidth >= 1080) {

      $('article section .container.container-grid.columns-2 ul li .content-wrapper').css({
        'left': ((contentWrapperWidth - 1062) / 2 + 'px')
      });
    } else {

      $('article section .container.container-grid.columns-2 ul li .content-wrapper').css({
        'left': ('0px')
      });
    }

  }




  var $window = $(window);
  var windowWidth = $window.width();

  var oneHeight = 600;
  var twoHeight = 1200;
  var oneAndHalfHeight = 900;
  var twoHeight = 1200;
  var quarterWidth = 600;
  var halfWidth = 1200;
  var fullWidth = 2400;

  var gridWidth = $('.container-grid').width();

  var scaleQuarter;
  var scaleThird;
  var scaleHalf;
  var scaleTwoThirds;
  var scaleFull;
  var scaleMultiplier = 1;
  // early exit
  if ((windowWidth >= (fullWidth + 20)) && (windowWidth > 0)) {
    $('.content').css({
      '-webkit-transform': ''
    });
    $('.content-wrapper').css({
      width: '',
      height: ''
    });
    return;
  }

  if ((windowWidth <= 768) && ($('body').hasClass('index'))) {
    // if(windowWidth<=768){
    scaleMultiplier = 2;
  }
  scaleQuarter = (((windowWidth - 18) / (quarterWidth)) / 4) * scaleMultiplier;
  scaleHalf = (((windowWidth - 18) / (halfWidth)) / 2) * scaleMultiplier;
  scaleFull = (((windowWidth - 18) / (fullWidth)) / 1) * scaleMultiplier;

  $('.width-one-quarter .content').css({
    '-webkit-transform': 'scale(' + scaleQuarter + ')',
    'transform': 'scale(' + scaleQuarter + ')'
  });
  $('.width-one-half .content').css({
    '-webkit-transform': 'scale(' + scaleHalf + ')',
    'transform': 'scale(' + scaleHalf + ')'
  });
  $('.width-one-full .content').css({
    '-webkit-transform': 'scale(' + scaleFull + ')',
    'transform': 'scale(' + scaleFull + ')'
  });

  $('.width-one-quarter .content-wrapper').css({
    width: (quarterWidth)
  });
  $('.width-one-half .content-wrapper').css({
    width: (halfWidth)
  });
  $('.width-one-full .content-wrapper').css({
    width: (fullWidth)
  });

  $('.height-one .content-wrapper').css({
    height: (oneHeight)
  });
  $('.height-one-and-half .content-wrapper').css({
    height: (oneAndHalfHeight)
  });
  $('.height-two .content-wrapper').css({
    height: (twoHeight)
  });

  if (($('body').hasClass('index'))) {

    if (windowWidth >= 1080) {
      animationScaleQuarter = (1 - (scaleQuarter / 1.2)) + 0.4425;
      animationScaleHalf = (1 - (scaleHalf / 1.2)) + 0.4425;
      $('.width-one-quarter .content .animation').not('.animation-ttt').css({
        '-webkit-transform': 'scale(' + animationScaleQuarter + ')',
        'transform': 'scale(' + animationScaleQuarter + ')'
      });
      $('.width-one-quarter .content .button').css({
        '-webkit-transform': 'scale(' + animationScaleQuarter + ')',
        'transform': 'scale(' + animationScaleQuarter + ')'
      });
      $('.width-one-half .content .animation').not('.animation-ttt').css({
        '-webkit-transform': 'scale(' + animationScaleHalf + ')',
        'transform': 'scale(' + animationScaleHalf + ')'
      });
      $('.width-one-half .content .button').css({
        '-webkit-transform': 'scale(' + animationScaleHalf + ')',
        'transform': 'scale(' + animationScaleHalf + ')'
      });

    } else {
      $('.width-one-quarter .content .animation').not('.animation-ttt').css({
        '-webkit-transform': 'scale(1)',
        'transform': 'scale(1)'
      });
      $('.width-one-quarter .content .button').css({
        '-webkit-transform': 'scale(1)',
        'transform': 'scale(1)'
      });
      $('.width-one-half .content .animation').not('.animation-ttt').css({
        '-webkit-transform': 'scale(1)',
        'transform': 'scale(1)'
      });
      $('.width-one-half .content .button').css({
        '-webkit-transform': 'scale(1)',
        'transform': 'scale(1)'
      });
    }

  }

};

function isVisible(row, container) {

  var offset = 0;
  if (row.hasClass('hero-banner')) {
    offset = 94;
  }
  var elementTop = $(row).offset().top + offset,
    elementHeight = $(row).height(),
    containerTop = container.scrollTop(),
    containerHeight = container.height();
  // console.log(elementTop+" elementTop");
  // console.log(elementHeight+" elementHeight");
  // console.log(containerTop+" containerTop");
  // console.log(containerHeight+" containerHeight");
  return ((((elementTop - containerTop) + elementHeight) > 0) && ((elementTop - containerTop) < containerHeight));
}

function show() {
  $('.reveal').each(function() {
    if ($('body').hasClass('index')) {

      if ($(this).hasClass('main-image')) {
        if (isVisible($(this), $(window))) {
          $(this).addClass('show');
        } else {
          $(this).removeClass('show');
        }
      }
      if ($(this).hasClass('hero-banner')) {
        if (isVisible($(this), $(window))) {
          $(this).addClass('show');
          $(this).addClass('colour-intro');
        } else {
          $(this).removeClass('colour-intro');
        }
      }
    }
    if (isVisible($(this), $(window))) {
      if (($('body').hasClass('page-tea-and-wellbeing')) || ($('body').hasClass('page-who-we-are')) || ($('body').hasClass('page-discover-rooibos'))) {

        if (($(this).hasClass('icon')) && (!$(this).hasClass('show'))) {
          var timing = 3500;
          var icon = $(this);
          var iconId = $(this).closest('section').attr('id');
          if (iconId == 'hero') {
            timing = 2100;
          } else if (iconId == 'healthy-attitude') {
            timing = 1500;
          } else if (iconId == 'gentle-hydration') {
            timing = 1100;
          } else if (iconId == 'bright-days') {
            timing = 2100;
          } else if (iconId == 'peaceful-nights') {
            timing = 1100;
          } else if (iconId == 'herbal-power') {
            timing = 1600;
          } else if (iconId == 'what-makes-us-tick') {
            timing = 2100;
          } else if (iconId == 'generation-game') {
            timing = 1900;
          } else if (iconId == 'family-values') {
            timing = 2200;
          } else if (iconId == 'tick-tock-spirit') {
            timing = 1100;
          } else if (iconId == 'roy-bosh') {
            timing = 1900;
          } else if (iconId == 'indi-genius') {
            timing = 1600;
          } else if (iconId == 'summer-sun') {
            timing = 2100;
          } else if (iconId == 'green-to-red') {
            timing = 1800;
          } else if (iconId == 'magic-kingdom') {
            timing = 1100;
          } else if (iconId == 'taste-tea') {
            timing = 1100;
          } else if (iconId == 'friend-with-benefits') {
            timing = 1100;
          }
          icon.addClass('intro');
          timer[iconId] = setTimeout(function() {
            icon.removeClass('intro');
          }, timing);

        }
        $(this).addClass('show');
      } else {
        $(this).addClass('show');
      }
    };
  });
  if ($('body').hasClass('page-original-tea-range') ||
    $('body').hasClass('page-wellbeing-tea-range')
  ) {
    if (isVisible($('#pre-footer'), $(window))) {
      $('.section').addClass('static-background');
    } else {
      $('.section').removeClass('static-background');
    };

  }
}

function positionTeaLink() {
  var scrollTop = $(window).scrollTop();
  var $window = $(window);
  var windowHeight = $window.height();
  var windowWidth = $window.width();
  var verticalPosition = scrollTop + (windowHeight / 2) - 220 + 94;
  var horizontalPosition = (windowWidth / 4) - 180;

  if (windowWidth > 2400) {
    $('.page-original-tea-range  .tea-link').css({
      'left': (((2400 / 4) - 180) + 'px'),
      'right': ('auto'),
      'margin': ('auto')
    });
    $('.page-original-tea-range #redbush-tea  .tea-link').css({
      'top': (verticalPosition + 'px')
    });
    $('.page-original-tea-range #organic-rooibos-green-tea  .tea-link').css({
      'top': (verticalPosition - windowHeight + 'px')
    });
    $('.page-original-tea-range #lemon-and-ginger-tea  .tea-link').css({
      'top': (verticalPosition - (windowHeight * 2) + 'px')
    });
    $('.page-original-tea-range #earl-grey-tea  .tea-link').css({
      'top': (verticalPosition - (windowHeight * 3) + 'px')
    });
    $('.page-original-tea-range #vanilla-tea  .tea-link').css({
      'top': (verticalPosition - (windowHeight * 4) + 'px')
    });
    $('.page-original-tea-range #vanilla-chai-tea  .tea-link').css({
      'top': (verticalPosition - (windowHeight * 5) + 'px')
    });
    if (!$('#organic-rooibos-restore-and-renew').hasClass('static-background')) {

      $('.page-original-tea-range #organic-rooibos-restore-and-renew  .tea-link').css({
        'top': (verticalPosition - (windowHeight * 6) + 'px')
      });
    }
  } else if (windowWidth > 768) {
    $('.page-original-tea-range  .tea-link').css({
      'left': (horizontalPosition + 'px'),
      'right': ('auto'),
      'margin': ('auto')
    });

    $('.page-original-tea-range #redbush-tea  .tea-link').css({
      'top': (verticalPosition + 'px')
    });
    $('.page-original-tea-range #organic-rooibos-green-tea  .tea-link').css({
      'top': (verticalPosition - windowHeight + 'px')
    });
    $('.page-original-tea-range #lemon-and-ginger-tea  .tea-link').css({
      'top': (verticalPosition - (windowHeight * 2) + 'px')
    });
    $('.page-original-tea-range #earl-grey-tea  .tea-link').css({
      'top': (verticalPosition - (windowHeight * 3) + 'px')
    });
    $('.page-original-tea-range #vanilla-tea  .tea-link').css({
      'top': (verticalPosition - (windowHeight * 4) + 'px')
    });
    $('.page-original-tea-range #vanilla-chai-tea  .tea-link').css({
      'top': (verticalPosition - (windowHeight * 5) + 'px')
    });
    if (!$('#organic-rooibos-restore-and-renew').hasClass('static-background')) {
      $('.page-original-tea-range #organic-rooibos-restore-and-renew  .tea-link').css({
        'top': (verticalPosition - (windowHeight * 6) + 'px')
      });
    }


  } else if (windowWidth > 600) {
    // $('.page-original-tea-range  .tea-link').css({
    //   'left': ('0px'),
    //   'right': ('0px'),
    //   'margin': ('auto')
    // });
  } else {
    // $('.page-original-tea-range  .tea-link').css({
    //   'left': (horizontalPosition + 'px')
    // });
  }

}

$(window).scroll(throttle(function(event) {

  show();
  if ($('body').hasClass('page-original-tea-range')) {
    positionTeaLink();
  }
  $('.section-animation').each(function() {

    if (isVisible($(this).find('.description-tea'), $(window))) {

      $(this).find('.inner-inner-holder').removeClass('un-animate');
      $(this).find('.inner-inner-holder').addClass('animate');
    }
    if (!isVisible($(this), $(window))) {

      $(this).find('.inner-inner-holder').addClass('un-animate');
      $(this).find('.inner-inner-holder').removeClass('animate');
    }

  });

}, 100));
//
// $(window).scroll(function(event) {
//
//     if (
//       // $('body').hasClass('page-original-tea-range') ||
//      $('body').hasClass('page-wellbeing-tea-range') ) {
//       ourTeas();
//     }
//
// });

var scroll = function() {
  ourTeas();

};
var raf = window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  window.oRequestAnimationFrame;
var $window = $(window);
var lastScrollTop = $window.scrollTop();

if (raf) {
  loop();
}

function loop() {
  var scrollTop = $window.scrollTop();
  if (lastScrollTop === scrollTop) {
    raf(loop);
    return;
  } else {
    lastScrollTop = scrollTop;

    // fire scroll function if scrolls vertically
    scroll();
    raf(loop);
  }
}

// $(window).scroll(function() {
//   show();
//   if ($('body').hasClass('page-original-tea-range') || $('body').hasClass('page-wellbeing-tea-range') ) {
//     positionTeaLink();
//   }
// });

$(window).resize(function() {
  show();
  if ($('body').hasClass('page-original-tea-range') || $('body').hasClass('page-wellbeing-tea-range')) {
    positionTeaLink();
  }
});

$(window).load(function() {
  show();
  if ($('body').hasClass('page-original-tea-range') || $('body').hasClass('page-wellbeing-tea-range')) {
    positionTeaLink();
  }
  // setTimeout(function() {
  $('.main-image').addClass('show');
  $('.hero-banner').addClass('show');
  $('.hero-banner').addClass('colour-intro');
  // alert('.');

  // }, 1000);
});

$(window).resize(scaler);
$(window).load(scaler);
$(window).load(scaler);



$(document).ready(function() {
  if ($('body').hasClass('page-our-teas')) {
    $('.image-slider').mouseenter(function() {
      $(this).addClass('active');

    }).mouseleave(function() {
      $(this).removeClass('active');
    });
  }

  if (
    // $('body').hasClass('page-original-tea-range') ||
    ($('body').hasClass('index')) ||
    ($('body').hasClass('page-wellbeing-tea-range'))) {
    $('.section-animation').each(function() {

      if (isVisible($(this).find('.description-tea'), $(window))) {
        var thisAnimation = $(this);
        setTimeout(
          function() {
            thisAnimation.find('.inner-inner-holder').addClass('animate');
            // thisAnimation.find('.inner-inner-holder').removeClass('un-animate');

          }, 100);
      }
      if (!isVisible($(this), $(window))) {
        // thisAnimation.find('.inner-inner-holder').addClass('un-animate');
        $(this).find('.inner-inner-holder').removeClass('animate');
      }

    });
    ourTeas();
  }

  $('.select-image').click(function(e) {
    var index = $(this).index();
    $('.product-image .image').hide();
    $('.product-image .image:eq(' + index + ')').show();
  })

  $("body").ihavecookies({
    message: "This site uses cookies to ensure that you receive the best experience on our website. Find out more about the cookies we use and how you can turn them off. Read our",
    expires: 30,
    link: "https://ticktocktea.com/pages/privacy-policy",
    moreInfoLabel: "Cookie Policy to find out more",
    cookieTypes: [{
      type: "Analytics",
      value: "analytics",
      description: "Cookies related to marketing, e.g. newsletters, social media, etc"
    }],
    onAccept: function() {
      if ($.fn.ihavecookies.preference("analytics")) {
        window['ga-disable-UA-49354887-2'] = false;
      }
    }
  })
  shopifyCart();

  // This button will increment the value
  $('[data-quantity="plus"]').click(function(e) {
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    fieldName = $(this).attr('data-field');
    parentContainer = $(this).closest('.plus-minus-input');
    quantityInput = parentContainer.find('input[name=' + fieldName + ']');
    // Get its current value
    var currentVal = parseInt((quantityInput).val());
    // If is not undefined
    if (!isNaN(currentVal)) {
      // Increment
      quantityInput.val(currentVal + 1);
    } else {
      // Otherwise put a 0 there
      quantityInput.val(1);
    }
  });
  // This button will decrement the value till 0
  $('[data-quantity="minus"]').click(function(e) {
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    fieldName = $(this).attr('data-field');
    parentContainer = $(this).closest('.plus-minus-input');
    quantityInput = parentContainer.find('input[name=' + fieldName + ']');
    // Get its current value
    var currentVal = parseInt((quantityInput).val());
    // If it isn't undefined or its greater than 0
    if (!isNaN(currentVal) && currentVal > 1) {
      // Decrement one
      quantityInput.val(currentVal - 1);
    } else {
      // Otherwise put a 0 there
      quantityInput.val(1);
    }
  });

  // Input field label for main site search.
  $(".input_field :input").focus(function(e) {
    $('label[for="' + $(this).attr('id') + '"]').hide();
  });

  $(".input_field :input").blur(function(e) {
    if ($(this).val() == "") {
      $('label[for="' + $(this).attr('id') + '"]').show();
    }
  });

  if ($('body').hasClass('index')) {


    // alert(2323);
    $('.main-image').addClass('show');
    $('.hero-banner').addClass('colour-intro show');



  }

  if (($('body').hasClass('page-our-history')) && ($(window).width() > 1062)) {

    // Get the id of the <path> element and the length of <path>
    var main_path_yellow_path = document.getElementById("main_path_yellow_path");
    var length = main_path_yellow_path.getTotalLength();

    // The start position of the drawing
    main_path_yellow_path.style.strokeDasharray = length;

    // Hide the main_path_yellow_path by offsetting dash. Remove this line to show the main_path_yellow_path before scroll draw
    main_path_yellow_path.style.strokeDashoffset = length;

    // Find scroll percentage on scroll (using cross-browser properties), and offset dash same amount as percentage scrolled

    window.addEventListener("scroll", myFunction);

    function myFunction() {
      var scrollTop = $(window).scrollTop();
      // if(scrollTop<150){
      //   return;
      // }
      sdo = main_path_yellow_path.style.strokeDashoffset;
      sdo = parseInt(sdo.replace(/[^-\d\.]/g, ''));
      // console.log(sdo+400);
      if (sdo < 8350) {
        var element = document.getElementById("teapot");
        element.classList.add("active");
      } else {
        var element = document.getElementById("teapot");
        element.classList.remove("active");
      }

      if (sdo < 7508) {
        var element = document.getElementById("circle_1");
        element.classList.add("active");
      } else {
        var element = document.getElementById("circle_1");
        element.classList.remove("active");
      }

      if (sdo < 7552) {
        var element = document.getElementById("dragonfly");
        element.classList.add("active");
      } else {
        var element = document.getElementById("dragonfly");
        element.classList.remove("active");
      }


      if (sdo < 6956) {
        var element = document.getElementById("mountains");
        element.classList.add("active");
      } else {
        var element = document.getElementById("mountains");
        element.classList.remove("active");
      }

      if (sdo < 6726) {
        var element = document.getElementById("flowers");
        element.classList.add("active");
      } else {
        var element = document.getElementById("flowers");
        element.classList.remove("active");
      }

      if (sdo < 6660) {
        var element = document.getElementById("picture_frame_2");
        element.classList.add("active");
      } else {
        var element = document.getElementById("picture_frame_2");
        element.classList.remove("active");
      }
      if (sdo < 6300) {
        var element = document.getElementById("sun_rays");
        element.classList.add("active");
      } else {
        var element = document.getElementById("sun_rays");
        element.classList.remove("active");
      }

      if (sdo < 5726) {
        var element = document.getElementById("boat");
        element.classList.add("active");
      } else {
        var element = document.getElementById("boat");
        element.classList.remove("active");
      }

      if (sdo < 5316) {
        var element = document.getElementById("picture_frame_3");
        element.classList.add("active");
      } else {
        var element = document.getElementById("picture_frame_3");
        element.classList.remove("active");
      }

      if (sdo < 5105) {
        var element = document.getElementById("clock");
        element.classList.add("active");
      } else {
        var element = document.getElementById("clock");
        element.classList.remove("active");
      }

      if (sdo < 4390) {
        var element = document.getElementById("calendar");
        element.classList.add("active");
      } else {
        var element = document.getElementById("calendar");
        element.classList.remove("active");
      }


      if (sdo < 4172) {
        var element = document.getElementById("chemical");
        element.classList.add("active");
      } else {
        var element = document.getElementById("chemical");
        element.classList.remove("active");
      }


      if (sdo < 3900) {
        var element = document.getElementById("picture_frame_4");
        element.classList.add("active");
      } else {
        var element = document.getElementById("picture_frame_4");
        element.classList.remove("active");
      }
      if (sdo < 3900) {
        var element = document.getElementById("picture_frame_5");
        element.classList.add("active");
      } else {
        var element = document.getElementById("picture_frame_5");
        element.classList.remove("active");
      }
      if (sdo < 3014) {
        var element = document.getElementById("hut");
        element.classList.add("active");
      } else {
        var element = document.getElementById("hut");
        element.classList.remove("active");
      }
      if (sdo < 2556) {
        var element = document.getElementById("stamp");
        element.classList.add("active");
      } else {
        var element = document.getElementById("stamp");
        element.classList.remove("active");
      }
      if (sdo < 2400) {
        var element = document.getElementById("r");
        element.classList.add("active");
      } else {
        var element = document.getElementById("r");
        element.classList.remove("active");
      }


      if (sdo < 1860) {
        var element = document.getElementById("picture_frame_6");
        element.classList.add("active");
      } else {
        var element = document.getElementById("picture_frame_6");
        element.classList.remove("active");
      }

      if (sdo < 1460) {
        var element = document.getElementById("flag");
        element.classList.add("active");
      } else {
        var element = document.getElementById("flag");
        element.classList.remove("active");
      }

      if (sdo < 1250) {
        var element = document.getElementById("picture_frame_7");
        element.classList.add("active");
      } else {
        var element = document.getElementById("picture_frame_7");
        element.classList.remove("active");
      }

      if (sdo < 760) {
        var element = document.getElementById("one");
        element.classList.add("active");
      } else {
        var element = document.getElementById("one");
        element.classList.remove("active");
      }
      if (sdo < 7830) {
        var element = document.getElementById("picture_frame_1");
        element.classList.add("active");
      } else {
        var element = document.getElementById("picture_frame_1");
        element.classList.remove("active");
      }

      if (sdo < 6155) {
        var element = document.getElementById("circle_2");
        element.classList.add("active");
      } else {
        var element = document.getElementById("circle_2");
        element.classList.remove("active");
      }

      if (sdo < 5087) {
        var element = document.getElementById("rain_cloud_white");
        element.classList.add("active");
      } else {
        var element = document.getElementById("rain_cloud_white");
        element.classList.remove("active");
      }

      if (sdo < 4862) {
        var element = document.getElementById("circle_3");
        element.classList.add("active");
      } else {
        var element = document.getElementById("circle_3");
        element.classList.remove("active");
      }

      if (sdo < 3574) {
        var element = document.getElementById("circle_4");
        element.classList.add("active");
      } else {
        var element = document.getElementById("circle_4");
        element.classList.remove("active");
      }

      if (sdo < 2164) {
        var element = document.getElementById("circle_5");
        element.classList.add("active");
      } else {
        var element = document.getElementById("circle_5");
        element.classList.remove("active");
      }

      if (sdo < 878) {
        var element = document.getElementById("circle_6");
        element.classList.add("active");
      } else {
        var element = document.getElementById("circle_6");
        element.classList.remove("active");
      }
      if (sdo < 502) {
        var element = document.getElementById("bus_white");
        element.classList.add("active");
      } else {
        var element = document.getElementById("bus_white");
        element.classList.remove("active");
      }
      if (sdo < 1) {
        var element = document.getElementById("cup");
        element.classList.add("active");
      } else {
        var element = document.getElementById("cup");
        element.classList.remove("active");
      }

      var scrollpercent = (document.body.scrollTop + (document.documentElement.scrollTop)) / (document.documentElement.scrollHeight - document.documentElement.clientHeight - 600);
      // console.log(document.body.scrollTop+"----"+document.documentElement.scrollTop+"----"+document.documentElement.scrollHeight+"----"+document.documentElement.clientHeight);
      // console.log(scrollpercent);
      var draw = (length) * scrollpercent;
      // console.log(draw);
      // console.log(scrollpercent);
      // if(draw > 8326){
      //   strokeDashoffset = 1;
      // }
      // Reverse the drawing (when scrolling upwards)
      var strokeDashoffset = length - draw + 400;
      if ((strokeDashoffset) < 0) {
        strokeDashoffset = 0;
      }
      main_path_yellow_path.style.strokeDashoffset = strokeDashoffset;

    }
  }



  // var animationTimer;
  // $(".content-animation").mouseenter(function() {
  //   // clearTimeout(animationTimer);
  //   // $(this).find('.animation').removeClass('animating');
  //   $(this).find('.animation').addClass('animating');
  // })
  // $(".content-animation").mouseleave(function() {
  //   animation = $(this).find('.animation');
  //   animationTimer = setTimeout(function() {
  //     animation.removeClass('animating');
  //     console.log(1);
  //   }, 1000);
  // })

  // var timer = [];

  // $(".content-animation").hover(function(){
  //
  //     $(this).find('.animation').addClass('animating');
  //
  // },function(){
  //   animation = $(this).find('.animation');
  //   setTimeout(function() {
  //     animation.removeClass('animating');
  //     console.log(1);
  //   }, 1000);
  // });




  $(".content-animation, .logo, .all-teas-button, .icon.animation").hover(function() {

    if ($(this).hasClass('logo')) {
      var logo = $(this);
      logo.addClass('animating');
      setTimeout(function() {
        logo.removeClass('animating');
      }, 1000);
      return;
    };
    if ($(this).hasClass('all-teas-button')) {
      var all_teas_button = $(this);
      all_teas_button.addClass('animating');
      setTimeout(function() {
        all_teas_button.removeClass('animating');
      }, 1000);

      return;
    };
    if ($('body').hasClass('index')) {
      var icon = $(this).find('.animation');
      var iconId = $(this).find('.animation').attr('id');
      // console.log(icon);
      // console.log(iconId);
      if (iconId == 'animation-sleep') {
        // console.log(222);
        timing = 1100;
      } else if (iconId == 'animation-thumb') {
        timing = 2100;
      } else if (iconId == 'animation-shop') {
        timing = 700;
      } else if (iconId == 'animation-milk') {
        timing = 1100;
      } else if (iconId == 'animation-caffeine') {
        timing = 1200;
      }
      if (icon.hasClass('animating')) {
        return false;
        clearTimeout(timer['icon']);
      } else {
        $(this).find('.animation').removeClass('animating');
        $(this).find('.animation').addClass('animating');
        var icon = $(this).find('.animation');
        timer['icon'] = setTimeout(function() {
          icon.removeClass('animating');
        }, timing);
      }
    }

    if (($('body').hasClass('page-tea-and-wellbeing')) || ($('body').hasClass('page-who-we-are')) || ($('body').hasClass('page-discover-rooibos'))) {

      var icon = $(this);
      var iconId = $(this).closest('section').attr('id');
      if (iconId == 'hero') {
        timing = 2100;
      } else if (iconId == 'healthy-attitude') {
        timing = 1500;
      } else if (iconId == 'gentle-hydration') {
        timing = 1100;
      } else if (iconId == 'bright-days') {
        timing = 2100;
      } else if (iconId == 'peaceful-nights') {
        timing = 1100;
      } else if (iconId == 'herbal-power') {
        timing = 1600;
      } else if (iconId == 'what-makes-us-tick') {
        timing = 2100;
      } else if (iconId == 'generation-game') {
        timing = 1900;
      } else if (iconId == 'family-values') {
        timing = 2200;
      } else if (iconId == 'tick-tock-spirit') {
        timing = 1100;
      } else if (iconId == 'roy-bosh') {
        timing = 1900;
      } else if (iconId == 'indi-genius') {
        timing = 1600;
      } else if (iconId == 'summer-sun') {
        timing = 2100;
      } else if (iconId == 'green-to-red') {
        timing = 1800;
      } else if (iconId == 'magic-kingdom') {
        timing = 1100;
      } else if (iconId == 'taste-tea') {
        timing = 1100;
      } else if (iconId == 'friend-with-benefits') {
        timing = 1100;
      }
      if (icon.hasClass('animating')) {
        return false;
        clearTimeout(timer['icon']);


      } else {

        $(this).removeClass('animating');
        $(this).addClass('animating');
        var icon = $(this);
        timer['icon'] = setTimeout(function() {
          icon.removeClass('animating');
        }, timing);
      }
    }
    // if ($('body').hasClass('index')) {
    //   var animation = $('#' + this.id + ' .animation');
    //   if (animation.hasClass('animating')) {
    //     clearTimeout(timer[this.id]);
    //
    //   } else {
    //
    //     $('#' + this.id + ' .animation').removeClass('animating');
    //     $('#' + this.id + ' .animation').addClass('animating');
    //   }
    // }
  }, function() {
    // if ($('body').hasClass('index')) {
    //   var animation = $('#' + this.id + ' .animation');
    //
    //   timer[this.id] = setTimeout(function() {
    //     animation.removeClass('animating');
    //   }, 1000);
    // } else {
    return false;
    // var icon = $(this);
    // timer['icon'] = setTimeout(function() {
    //   icon.removeClass('animating');
    // }, 3500);
    // }

  });
  $('.popup').click(function() {
    url = this.href;
    popupWindow = window.open(url, 'popUpWindow', 'height=500,width=500,resizable=yes,toolbar=no,menubar=no,location=no,directories=no, status=yes');
    return false;
  });
  $('.header-link.menu a').click(function() {
    $('.mobile-navigation').addClass('toggled');
    return false;
  });
  $('.shop-header .filter').click(function() {
    $('.shop-header ul').toggleClass('toggled');
    return false;
  });
  $('.ttt-header .filter').click(function() {
    $('.ttt-header ul').toggleClass('toggled');
    return false;
  });
  $('.mobile-navigation .close-menu').click(function() {
    $('.mobile-navigation').removeClass('toggled');
    return false;
  });

  $('.all-teas-menu a,.all-teas-button,.section').click(function() {
    if ($('.all-teas-menu').hasClass('bounceInDown')) {
      $('.all-teas-menu').addClass('bounceOutUp');
      $('.all-teas-menu').removeClass('bounceInDown');
    } else {
      if ($(this).hasClass('section')) {
        return;
      }
      if (!$('.bubble').hasClass('blueRubberBandDown') && (!$('.header-navigation').hasClass('initial'))) {
        navigationAnimation('blueRubberBandDown');
        $('.header-navigation').removeClass('initial');
      }
      if (!$('.bubble-2').hasClass('blueRubberBandDown') && (!$('.header-navigation').hasClass('initial'))) {
        navigationAnimation('blueRubberBandDown');
        $('.header-navigation-2').removeClass('initial');
      }
      $('.all-teas-menu').addClass('bounceInDown');
      $('.all-teas-menu').removeClass('bounceOutUp');
    }
  });

  $('.icon-make-the-perfect-cup').hover(function() {
    $(this).find('img').removeClass('svg-white');
    $(this).closest('.text').addClass('make-the-perfect-cup-active');
    $('.visible-text').addClass('make-the-perfect-cup-active');
  }, function() {
    $(this).find('img').addClass('svg-white');
    $(this).closest('.text').removeClass('make-the-perfect-cup-active');
    $('.visible-text').removeClass('make-the-perfect-cup-active');
  });

  $('.icon-organic').hover(function() {
    // console.log(222);
    $(this).find('img').removeClass('svg-white');
    $(this).closest('.text').addClass('organic-active');
    $('.visible-text').addClass('organic-active');

  }, function() {
    $(this).find('img').addClass('svg-white');
    $(this).closest('.text').removeClass('organic-active');
    $('.visible-text').removeClass('organic-active');
  });

  $('.icon-caffeine-free').hover(function() {
    $(this).find('img').removeClass('svg-white');
    $(this).closest('.text').addClass('caffeine-free-active');
    $('.visible-text').addClass('caffeine-free-active');

  }, function() {
    $(this).find('img').addClass('svg-white');
    $(this).closest('.text').removeClass('caffeine-free-active');
    $('.visible-text').removeClass('caffeine-free-active');
  });

  $('.icon-allows-restful-sleep').hover(function() {
    $(this).find('img').removeClass('svg-white');
    $(this).closest('.text').addClass('allows-restful-sleep-active');
    $('.visible-text').addClass('allows-restful-sleep-active');

  }, function() {
    $(this).find('img').addClass('svg-white');
    $(this).closest('.text').removeClass('allows-restful-sleep-active');
    $('.visible-text').removeClass('allows-restful-sleep-active');
  });

  $('.content-spinner').click(function() {
    randomNumber = Math.floor(Math.random() * 10);
    if ($(this).hasClass('spun')) {
      if ($(this).hasClass('organic-green')) {
        window.location.href = "https://ticktocktea.com/products/tick-tock-rooibos-green-organic-40-bags";
      } else if ($(this).hasClass('redbush')) {
        window.location.href = "https://ticktocktea.com/products/tick-tock-rooibos-organic-40-bags";
      } else if ($(this).hasClass('earl-grey')) {
        window.location.href = "https://ticktocktea.com/products/tick-tock-rooibos-earl-grey-tea-40-bags";
      } else if ($(this).hasClass('vanilla')) {
        window.location.href = "https://ticktocktea.com/products/rooibos-vanilla";
      } else if ($(this).hasClass('vanilla-chai')) {
        window.location.href = "https://ticktocktea.com/products/tick-tock-rooibos-vanilla-chai-40-bags";
      } else if ($(this).hasClass('detox-rooibos-tea')) {
        window.location.href = "https://ticktocktea.com/products/tick-tock-rooibos-detox-restore-renew-40-bags";
      } else if ($(this).hasClass('lemon-and-ginger')) {
        window.location.href = "https://ticktocktea.com/products/rooibos-lemon-and-ginger-1";
      } else if ($(this).hasClass('wellbeing')) {
        window.location.href = "https://ticktocktea.com/pages/tea-and-wellbeing";
      } else if ($(this).hasClass('who-we-are')) {
        window.location.href = "https://ticktocktea.com/pages/who-we-are";
      } else if ($(this).hasClass('discover-rooibos')) {
        window.location.href = "https://ticktocktea.com/pages/discover-rooibos";
      }
    }
    if (randomNumber == 0) {
      $(this).addClass('organic-green');
    } else if (randomNumber == 1) {
      $(this).addClass('redbush');
    } else if (randomNumber == 2) {
      $(this).addClass('earl-grey');
    } else if (randomNumber == 3) {
      $(this).addClass('vanilla');
    } else if (randomNumber == 4) {
      $(this).addClass('vanilla-chai');
    } else if (randomNumber == 5) {
      $(this).addClass('detox-rooibos-tea');
    } else if (randomNumber == 6) {
      $(this).addClass('lemon-and-ginger');
    } else if (randomNumber == 7) {
      $(this).addClass('wellbeing');
    } else if (randomNumber == 8) {
      $(this).addClass('who-we-are');
    } else {
      $(this).addClass('discover-rooibos');
    }
    $(this).addClass('spinning');
    setTimeout(function() {
      $('.spin-text').html('click to visit');
    }, 2000);
    setTimeout(function() {
      $('.spin-text').addClass('visit-text');
      $('.content-spinner').addClass('spun');
    }, 5000);
    return false
  });

  $('.page-our-history .scroll-down').click(function() {
    // console.log(333);
    var anchorLink = '#picture_frame_1';
    // console.log(anchorLink);
    var offset = 0;
    if (($(window).width() < 1063) && ($(window).width() > 499)) {
      offset = 400;
    } else if (($(window).width() < 500)) {
      offset = 500;

    }
    var scrollPosition = $(anchorLink).offset().top - offset;
    // console.log(scrollPosition);
    $('html, body').animate({
      scrollTop: scrollPosition
    }, {
      duration: 1250,
      easing: 'swing',
      complete: function() {}
    })
    return false;

  });


  $('.page-our-history .scroll-up').click(function() {
    // console.log(22);
    // console.log(34);
    var scrollPosition = 0;
    // console.log(scrollPosition);
    $('html, body').animate({
      scrollTop: scrollPosition
    }, {
      duration: 1250,
      easing: 'swing',
      complete: function() {}
    })
    return false

  });


  $('.scroll-link').click(function() {
    var anchorLink = $(this).attr('href');

    if ($(this).hasClass('original-tea-link')) {
      if ($('body').hasClass('page-original-tea-range')) {
        anchorLink = anchorLink.substring(anchorLink.indexOf("#"));
      }
    } else if ($(this).hasClass('wellbeing-tea-link')) {
      if ($('body').hasClass('page-wellbeing-tea-range')) {
        anchorLink = anchorLink.substring(anchorLink.indexOf("#"));
      }

    }

    // console.log(anchorLink);
    var scrollPosition = $(anchorLink).offset().top;
    // console.log(scrollPosition);
    $('html, body').animate({
      scrollTop: scrollPosition
    }, {
      duration: 750,
      easing: 'swing',
      complete: function() {}
    })
    return false

  });



  $('.top').click(function() {
    // console.log(22);
    // console.log(34);
    var scrollPosition = 0;
    // console.log(scrollPosition);
    $('html, body').animate({
      scrollTop: scrollPosition
    }, {
      duration: 750,
      easing: 'swing',
      complete: function() {}
    })
    return false

  });
  $('.scroll-down, .scroll').click(function() {
    // console.log(22);
    // console.log(34);
    if ($('body').hasClass('page-our-history')) {
      return;
    }

    var scrollPosition = $("section:nth-child(2)").offset().top + 2;
    if (($('body').hasClass('page-tea-and-wellbeing')) || ($('body').hasClass('page-who-we-are')) || ($('body').hasClass('page-discover-rooibos'))) {
      scrollPosition = $("section:nth-child(3)").offset().top + 2;
    }
    // console.log(scrollPosition);
    $('html, body').animate({
      scrollTop: scrollPosition
    }, {
      duration: 750,
      easing: 'swing',
      complete: function() {}
    })
    return false

  });
  scaler();

  $('.header-link.lets-talk-tea').mouseenter(function() {


    $('.header-navigation').removeClass('initial');

    if ((!$('.header-navigation').hasClass('slideInDown'))) {

      // navigationAnimation('show');
      navigationAnimation_2('show');

    }
  });

  $('.header-link.lets-talk-tea').mousemove(function() {

    $('.header-navigation').removeClass('initial');


    if ((!$('.header-navigation').hasClass('slideInDown'))) {
      //navigationAnimation('show');
      navigationAnimation_2('show');
    }
  });

  $('.header-link.lets-shop').mouseenter(function() {


    $('.header-navigation-2').removeClass('initial');

    if ((!$('.header-navigation-2').hasClass('slideInDown'))) {

      //navigationAnimation_2('show');
      navigationAnimation('show');

    }
  });

  $('.header-link.lets-shop').mousemove(function() {

    $('.header-navigation-2').removeClass('initial');


    if ((!$('.header-navigation-2').hasClass('slideInDown'))) {
      //navigationAnimation_2('show');
      navigationAnimation('show');
    }
  });


  $('article').mouseenter(function() {
    // $('.header-navigation').removeClass('initial');
    // console.log(111);

    // if ($('body').hasClass('lets-talk')) {
    //   console.log(111);
    //   navigationAnimation('hide');
    // }
    // if ($('body').hasClass('lets-shop')) {
    //   console.log(222);
    //   navigationAnimation_2('hide');
    // }
    if (($('.header-navigation').hasClass('slideInDown')) && (!$('.header-navigation').hasClass('initial'))) {
      // console.log(44);
      navigationAnimation('hide');
    }

    if (($('.header-navigation-2').hasClass('slideInDown')) && (!$('.header-navigation-2').hasClass('initial'))) {
      // console.log(44);
      navigationAnimation_2('hide');
    }
  });

  $('article').mousemove(function() {
    // $('.header-navigation').removeClass('initial');

    // if ($('body').hasClass('lets-talk')) {
    //   console.log(111);
    //   navigationAnimation('hide');
    // }
    // if ($('body').hasClass('lets-shop')) {
    //   console.log(222);
    //   navigationAnimation_2('hide');
    // }
    if (($('.header-navigation').hasClass('slideInDown')) && (!$('.header-navigation').hasClass('initial'))) {
      // console.log(44);
      navigationAnimation('hide');
    }

    if (($('.header-navigation-2').hasClass('slideInDown')) && (!$('.header-navigation-2').hasClass('initial'))) {
      // console.log(44);
      navigationAnimation_2('hide');
    }
  });

  var lastScrollTop = 0;
  $(window).scroll(throttle(function(event) {
    var st = $(this).scrollTop();

    if (st > lastScrollTop) {
      if (st > 100) {

        if ((!$('.bubble').hasClass('blueRubberBandDown')) && (!$('.header-navigation').hasClass('initial'))) {
          navigationAnimation('hide');
        }
        if ((!$('.bubble-2').hasClass('blueRubberBandDown')) && (!$('.header-navigation-2').hasClass('initial'))) {
          navigationAnimation_2('hide');
        }

        $('#site-header').addClass('headerSlideOutUp').removeClass('headerSlideInDown');
      }
    } else {
      // if ((!$('.header-navigation').hasClass('slideInDown')) ) {
      //   navigationAnimation('show');
      //   $('.header-navigation').removeClass('initial');
      // }
      $('#site-header').addClass('headerSlideInDown').removeClass('headerSlideOutUp');

    }
    lastScrollTop = st;
  }, 500));

  var $owl_1 = $('.carousel-1').owlCarousel({
    loop: true,
    animateOut: 'fadeOut',
    mouseDrag: false,
    autoplay: true,
    autoplayTimeout: 4000,
    smartSpeed: 1000,
    autoplayHoverPause: true,
    margin: 0,
    nav: false,
    dots: true,
    startPosition: 1,
    responsive: {
      0: {
        items: 1
      }
    }
  })


  var $owl_2 = $('.carousel-2').owlCarousel({
    loop: true,
    animateOut: 'fadeOut',
    mouseDrag: false,
    autoplay: true,
    autoplayTimeout: 4000,
    smartSpeed: 1000,
    autoplayHoverPause: true,
    margin: 0,
    nav: false,
    dots: true,
    startPosition: 2,
    responsive: {
      0: {
        items: 1
      }
    }
  })

  var $owl_3 = $('.carousel-3').owlCarousel({
    loop: true,
    animateOut: 'fadeOut',
    mouseDrag: false,
    autoplay: true,
    autoplayTimeout: 4000,
    smartSpeed: 1000,
    autoplayHoverPause: true,
    margin: 0,
    nav: false,
    dots: true,
    startPosition: 3,
    responsive: {
      0: {
        items: 1
      }
    }
  })

  var $owl_4 = $('.carousel-4').owlCarousel({
    loop: true,
    animateOut: 'fadeOut',
    mouseDrag: false,
    autoplay: true,
    autoplayTimeout: 4000,
    smartSpeed: 1000,
    autoplayHoverPause: true,
    margin: 0,
    nav: false,
    dots: true,
    startPosition: 4,
    responsive: {
      0: {
        items: 1
      }
    }
  })



});


$.fn.redraw = function() {
  $(this).each(function() {
    var redraw = this.offsetHeight;
  });
};
// balance-tea
// bounce-tea
// bedtime-tea
function ourTeas() {
  scrollTop = $(window).scrollTop();
  // $('.section').redraw();
  // console.log(new Date($.now()));

    var windowWidth = $window.width();

    if (windowWidth > 768) {


  $('.section').each(function() {
    holder = $(this).find('.inner-holder');
    offSet = $(this).offset().top;
    // if(scrollTop<offSet){
    newHeight = $(window).height() - (offSet - scrollTop);
    holder.height(newHeight);
    // }
  })}



}
